import { getStandarisedInternationalSOSMedicalRiskRating } from './utils'

export const getFilteredAirports = (searchInput, airportsData) => {
    const filteredAirports = []

    let searchValue = searchInput.toLowerCase().trim()
    if (searchValue.indexOf(' and ') > -1) searchValue = searchValue.replace(' and ', ' & ')

    // Search airports
    airportsData.forEach(airport => {
        let exactMatch = false
        let anyMatchFound = false

        const cityName = airport.City.toLowerCase()
        if (cityName === searchValue) {
            anyMatchFound = true
            exactMatch = true
        } else if (cityName.indexOf(searchValue) > -1) {
            anyMatchFound = true
        }
        
        // Special condition
        if (!anyMatchFound) {
            if (searchValue === 'united states') {
                if (airport.Country.toLowerCase().indexOf(searchValue) > -1 || airport.Country === 'USA') anyMatchFound = true
            } 
            
            if (!anyMatchFound && airport.Country.toLowerCase() === searchValue) {
                anyMatchFound = true
                exactMatch = true
            }
            
            if (!anyMatchFound && airport.Country.toLowerCase().indexOf(searchValue) > -1) anyMatchFound = true
        } 

        if (!anyMatchFound && airport.IATA.toLowerCase() === searchValue) {
            anyMatchFound = true
            exactMatch = true  
        } 
        if (!anyMatchFound && airport.IATA.toLowerCase().indexOf(searchValue) > -1) anyMatchFound = true

        if (!anyMatchFound && airport.ICAO.toLowerCase() === searchValue) {
            anyMatchFound = true
            exactMatch = true  
        }
        if (!anyMatchFound && airport.ICAO.toLowerCase() === searchValue) {
            anyMatchFound = true
        }

        if (!anyMatchFound && (airport.Name + ' Airport').toLowerCase() === searchValue) {
            anyMatchFound = true
            exactMatch = true 
        }
        if (!anyMatchFound && (airport.Name + ' Airport').toLowerCase().indexOf(searchValue) > -1) anyMatchFound = true

        if (anyMatchFound) {
            if (exactMatch) {
                filteredAirports.unshift(getAirportDetailProperties(airport))
            } else {
                filteredAirports.push(getAirportDetailProperties(airport))
            }
        }
    })
    
    return filteredAirports
}

export const getAirportDetailProperties = (airport) => {
    // If we don't have a city rating, then the city should inherit from the country rating. See https://internationalsos.atlassian.net/browse/AVS-307 for details
    let cityRating = airport?.Ratings?.city
    let inheritedCityRating = false
    if (cityRating === 0) {
      cityRating = airport?.Ratings?.country
      inheritedCityRating = true
    }

    // Asked by client to put airspace rating of 1, if there is no airspace rating
    let airspaceRating = airport?.Ratings?.AirspaceRating
    if (!airspaceRating || airspaceRating === 0) airspaceRating = 1

    let medicalRating = getStandarisedInternationalSOSMedicalRiskRating(airport?.Ratings?.medical)

    return {
        ['iconName']: 'airport-icon',
        ['airportId']: airport?.Id,
        ['icao']: airport?.ICAO,
        ['iata']: airport?.IATA,
        // We use this field to handle the display of the airport code for IATA
        // If user's preference is to see IATA code, but the airport doesn't have it, then we display ICAO as alternative, instead of nothing
        ['displayIATA']: !!airport?.IATA ? airport?.IATA : airport?.ICAO, 
        ['airportName']: airport?.Name,
        ['type']: airport?.Type,
        ['cityName']: airport?.City,
        ['countryCode']: airport?.Isocode,
        ['countryCode3']: airport?.Isocode3,
        ['country']: airport?.Country,
        ['latitude']: airport?.Lat,
        ['longitude']: airport?.Lng,
        ['airportOfEntry']: airport?.AirportOfEntry,
        ['travelRating']: airport?.Ratings?.travel,
        ['medicalRating']: medicalRating,
        ['countryRating']: airport?.Ratings?.country,
        ['securityRating']: cityRating, // As decided the security rating for the airport will be the city rating
        ['airportRating']: airport?.Ratings?.AirportRating,
        ['airspaceRating']: airspaceRating,
        ['cityRating']: cityRating,
        ['inheritedCityRating']: inheritedCityRating,
        ['timeZone']: airport?.TimeZone,
        ['elevation']: airport?.Elevation
    }
}